import { get } from "./AXIOS";
import { DOWNLOAD_ANALYTICS } from "./CONSTANTS";

export const downloadAnalytics = query =>
    get(
      `${DOWNLOAD_ANALYTICS}?${query}`
    )